import { createAsyncThunk } from '@reduxjs/toolkit'
import { ICallTrackingAccount } from '@user/features/CampaignTracking/typings'
import { ServiceConfig } from '../services/config'
import { post, APIError, get } from '../services/crud'
import { ICallTrackingAccountDTO, ICallTrackingProvider } from './typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.integrations.callTracking}`

export const syncCallTracking = createAsyncThunk<
  void,
  ICallTrackingAccount,
  { rejectValue: APIError }
>('callTracking/sync', async (input, thunkApi) => {
  const response = await post(`${baseUrl}/sync`, input)

  if (!response.ok) {
    return thunkApi.rejectWithValue(await response.json())
  }
  return
})

export const disconnectCallTrackingProvider = createAsyncThunk<
  void,
  number,
  { rejectValue: APIError }
>('callTracking/disconnect', async (providerId, thunkApi) => {
  const response = await post(`${baseUrl}/${providerId}/disconnect`)

  if (!response.ok) {
    return thunkApi.rejectWithValue(await response.json())
  }
  return
})

export const getCallTracking = createAsyncThunk<
  ICallTrackingAccountDTO,
  number,
  { rejectValue: APIError }
>('callTracking/fetch', async (providerId, thunkApi) => {
  const response = await get(`${baseUrl}/${providerId}`)

  if (response.ok) {
    const callTrackingAcct: ICallTrackingAccountDTO = await response.json()
    return callTrackingAcct
  }

  return thunkApi.rejectWithValue(await response.json())
})

export const getCallTrackingProviders = createAsyncThunk<
  ICallTrackingProvider[],
  void,
  { rejectValue: APIError }
>('callTracking/fetchProviders', async (_, thunkApi) => {
  const response = await get(`${baseUrl}`)

  if (response.ok) {
    const callTrackingProviders: ICallTrackingProvider[] = await response.json()
    return callTrackingProviders
  }

  return thunkApi.rejectWithValue(await response.json())
})
